/* eslint-disable react/jsx-props-no-spreading */

// import React from 'react'
import { Experience } from '@ninetailed/experience.js-react'
import { mapNtExperiences } from '@/utils/ninetailed'
import PasswordGenerator from '@/components/section-password-generator'
import PasswordStrengthTester from '@/components/section-password-test'
import PasswordStrengthTable from '@/components/password-strength-table'
import HostForm from '@/components/forms/host'
import JobsList from '@/components/ui/jobs-list'
import ComparisonGrid from '@/components/ui/comparison-grid'
import DownloadTabs from '@/components/ui/download-tabs'

type PrebuiltProps = {
  name: string
  properties: any
}

export function PrebuiltComponent({ name, properties }: PrebuiltProps): JSX.Element {
  return (
    <>
      {name === 'Password Generator' && <PasswordGenerator data={{ ...properties, generateType: 'password' }} />}
      {name === 'Passphrase Generator' && <PasswordGenerator data={{ ...properties, generateType: 'passphrase' }} />}
      {name === 'Username Generator' && <PasswordGenerator data={{ ...properties, generateType: 'username' }} />}
      {name === 'Password Strength Tester' && <PasswordStrengthTester />}
      {name === 'Host Form' && <HostForm data={properties} />}
      {name === 'Jobs list' && <JobsList jobs={properties} />}
      {name === 'Password Strength Table' && <PasswordStrengthTable tableData={properties} />}
      {(name === 'Business Comparison Table' ||
        name === 'Individual Comparison Table' ||
        name === 'Secrets Manager Plans' ||
        name === 'Business Comparison Table - Teams Variant' ||
        name === 'Business Comparison Table - Teams Baseline' ||
        name === 'Bitwarden Product Comparison') && <ComparisonGrid data={properties} />}
      {name === 'Download Extension' && <DownloadTabs {...properties} type="browsers" />}
      {name === 'Download Applications' && <DownloadTabs {...properties} type="os" />}
    </>
  )
}

export default function Prebuilt({ nt_experiences, id, ...props }: any): JSX.Element {
  return (
    <Experience
      {...props}
      id={id}
      key={id}
      experiences={mapNtExperiences(nt_experiences)}
      component={PrebuiltComponent}
      passthroughProps={{ ...props }}
    />
  )
}
